import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { PROMOTIONAL_CARD_BASE_CLASSNAME } from './Constants';
import { createPromotionalCard } from './PromotionalCard';
createComponents(".".concat(PROMOTIONAL_CARD_BASE_CLASSNAME), createPromotionalCard, NO_PATTERN_BUSINESS_LOGIC);
